import axios from 'axios';

const BASE = process.env.REACT_APP_BACKEND_URL;

export const api = axios.create({ baseURL: BASE, withCredentials: true });

// Attach token from localStorage on every request (cookies also work but this is more robust in preview).
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('goldcare_admin_token');
  if (token) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export default api;
